import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useMediaQuery,
} from '@mui/material';
import { Breakpoint, useTheme } from '@mui/material/styles';
import { ReactNode, memo } from 'react';

interface ConfirmationDialogProps {
    address?: string;
    checkValue?: boolean;
    content: ReactNode;
    handle?: boolean;
    handleDevice: (...arg: unknown[]) => void;
    info?: unknown;
    isDisabled?: boolean;
    maxWidth?: Breakpoint;
    name: string;
    noAction?: boolean;
    open: boolean;
    setOpen: (val: boolean) => void;
    value?: unknown;
}

interface WithArrTitle extends ConfirmationDialogProps {
    stringTitle?: false;
    title: string[];
}

interface WithStringTitle extends ConfirmationDialogProps {
    stringTitle: true;
    title: string;
}

const ConfirmationDialog = memo(function ConfirmationDialogComponent({
    address,
    checkValue,
    content,
    handle,
    handleDevice,
    info,
    isDisabled,
    maxWidth,
    name,
    noAction,
    open,
    setOpen,
    stringTitle,
    title,
    value,
}: Readonly<WithArrTitle | WithStringTitle>) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            aria-describedby="alert-dialog-description"
            aria-labelledby="alert-dialog-title"
            maxWidth={maxWidth ? maxWidth : undefined}
            onClose={() => setOpen(false)}
            open={open}
        >
            <DialogTitle
                id="alert-dialog-title"
                sx={
                    !isSmall ? { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: 350 } : null
                }
            >
                {stringTitle
                    ? `${title} ${name}?`
                    : name
                      ? checkValue
                          ? `${title[1]} ${name}?`
                          : info
                            ? `${title[0]} ${name}`
                            : `${title[0]} ${name}?`
                      : `${title[0]} Device?`}
            </DialogTitle>
            {address ? (
                isSmall ? (
                    <DialogTitle id="alert-dialog-subtitle" noWrap sx={{ color: 'gray', marginTop: -3 }}>
                        {`Device ID: ${address}`}
                    </DialogTitle>
                ) : (
                    <DialogTitle id="alert-dialog-subtitle" noWrap sx={{ position: 'absolute', right: 0 }}>
                        {`Device ID: ${address}`}
                    </DialogTitle>
                )
            ) : null}
            <DialogContent sx={{ width: '100%' }}>
                <DialogContentText component="div" id="alert-dialog-description">
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)} variant="outlined">
                    Close
                </Button>
                {!noAction && (
                    <Button
                        disabled={isDisabled}
                        onClick={
                            handle
                                ? () => {
                                      handleDevice();
                                      setOpen(false);
                                  }
                                : () => {
                                      handleDevice(value ? value : address);
                                      setOpen(false);
                                  }
                        }
                        variant="contained"
                    >
                        {stringTitle ? title : checkValue ? title[1] : title[0]}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
});

export default ConfirmationDialog;
